var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"storeTop"},[(_vm.shopData.CompanyNameDisplayType == 1)?_c('div',{staticClass:"box",style:({
      background: _vm.shopData.BackgroundColorCode
    })},[_c('span',{staticClass:"text",style:({
        color: _vm.shopData.CharacterColorCode
      })},[_vm._v(_vm._s(_vm.shopData.CompanyName))])]):_c('div',{staticClass:"box",style:({
      'background-image':
        'url(' + _vm.imgUrlFilter(_vm.shopData.CompanyNameImage) + ')'
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }